import { Alert, Button, Form, Input } from 'antd';
import styles from './LoginForm.module.scss'
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { login } from '../../util/AuthHelper';
import { Navigate, useLocation } from 'react-router-dom';

export const LoginForm = () => {
    const auth = useAuth()
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState(null)

    const location = useLocation()
    //Never send the user back to the login or logout pages after signing in
    const fromPath = location.state?.from?.pathname
    const from = fromPath && !['/login', '/logout'].includes(fromPath) ? fromPath : "/"

    const onFinish = (values) => {
        setSubmitting(true)
        setError(null)
        login(values.username, values.password)
            .then(res => {
                //Re-renders with auth.user set, which redirects below
                auth.updateAuth(res)
            })
            .catch(err => {
                setError(err.message)
                setSubmitting(false)
            })
    };

    //Same check as RequireAuth, so the two can't redirect back and forth
    if (auth?.user) {
        return <Navigate to={from} replace />
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.card}>
                <h1 className={styles.title}>Sign in</h1>
                {error && <Alert className={styles.alert} type="error" message={error} showIcon />}
                <Form
                    name="login"
                    layout="vertical"
                    onFinish={onFinish}
                    requiredMark={false}
                >
                    <Form.Item
                        label="Email"
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter your email!',
                            },
                            {
                                type: 'email',
                                message: 'Please enter a valid email!',
                            },
                        ]}
                    >
                        <Input autoComplete="username" autoFocus />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter your password!',
                            },
                        ]}
                    >
                        <Input.Password autoComplete="current-password" />
                    </Form.Item>

                    <Form.Item className={styles.submit}>
                        <Button type="primary" htmlType="submit" loading={submitting} block>
                            Sign in
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
